import {useCallback} from 'react';

import {getHttpMonitorDisplayName} from 'features/http/lib/httpMonitorView';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import useOpenState, {IOpenState} from 'shared/lib/hooks/useOpenState';
import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import {IHttpMonitorItem} from './HttpMonitor/IHttpMonitor';
import {useHttpMonitorCheckNow} from './useHttpMonitorMutations';

export interface IUseHttpMonitorHeader {
    displayName: string,
    isCompact: boolean,
    editModal: IOpenState,
    deleteModal: IOpenState,
    pauseModal: IOpenState,
    resumeModal: IOpenState,
    onCheckNow: () => Promise<void>,
    onActivate: () => void,
    onEditClick: () => void,
    onPauseClick: () => void,
    onDeleteClick: () => void,
}

export const useHttpMonitorHeader = (item: IHttpMonitorItem): IUseHttpMonitorHeader => {
    const breakpoint = useBreakpoint();
    const editModal = useOpenState();
    const deleteModal = useOpenState();
    const pauseModal = useOpenState();
    const resumeModal = useOpenState();

    const onCheckNow = useHttpMonitorCheckNow(item.uuid);

    const {open: openEdit} = editModal;
    const {open: openPause} = pauseModal;
    const {open: openDelete} = deleteModal;

    const onEditClick = useCallback(() => {
        reachGoal(YM_GOALS.EDIT_MONITOR_DETAIL);
        openEdit();
    }, [openEdit]);

    const onPauseClick = useCallback(() => {
        reachGoal(YM_GOALS.PAUSE_MONITOR_DETAIL);
        openPause();
    }, [openPause]);

    const onDeleteClick = useCallback(() => {
        reachGoal(YM_GOALS.DELETE_MONITOR_DETAIL);
        openDelete();
    }, [openDelete]);

    return {
        displayName: getHttpMonitorDisplayName(item.name),
        isCompact: breakpoint === 'small' || breakpoint === 'mini',
        editModal,
        deleteModal,
        pauseModal,
        resumeModal,
        onCheckNow,
        onActivate: resumeModal.open,
        onEditClick,
        onPauseClick,
        onDeleteClick,
    };
};

export default useHttpMonitorHeader;
